import { connect } from 'react-redux';
import {
  loginWithCredentials,
  authActionNames,
} from 'services/store/auth/actions';
import {
  checkErrorSelector,
  checkLoadingSelector,
} from 'services/store/base/selectors';

import LoginForm from './LoginForm';

// @ts-ignore
const mapStateToProps = ({ base, auth }) => ({
  auth,
  isLoading: checkLoadingSelector(base, [
    authActionNames.LOGIN_WITH_CREDENTIALS,
  ]),
  loginError: checkErrorSelector(base, [
    authActionNames.LOGIN_WITH_CREDENTIALS,
    authActionNames.LOGIN_TO_APP,
  ]),
});

// @ts-ignore
const mapDispatchToProps = (dispatch) => ({
  // @ts-ignore
  loginWithCredentials: (formData): void => {
    dispatch(loginWithCredentials(formData));
  },
});

// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(LoginForm);
